import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useAuth0 } from '@auth0/auth0-react';

interface LogoutButtonProps {
  onLogout?: () => void;
}

const LogoutButton = ({ onLogout }: LogoutButtonProps) => {
  const { logout } = useAuth0();

  const handleClick = () => {
    onLogout?.();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <MenuItem onClick={handleClick}>
      <Typography component="div" textAlign="center">
        Log Out
      </Typography>
    </MenuItem>
  );
};

export default LogoutButton;
